import OpenCommentPanel from 'actions/task/open_comment_panel';
import ToggleSidePanels from 'actions/task/toggle_side_panels';

export default class OpenOrRefreshCommentPanel {
  constructor(context) {
    this.context = context;
  }

  run({ itemId, location }) {
    const commentPanel = this.context.stores.commentPanel.get();
    this.context.analytics.track('Task Comment Panel Opened', {
      itemId,
      location,
    });
    if (commentPanel.isOpen()) {
      // only load comments for new item
      this.context.executeAction(OpenCommentPanel, { itemId });
    } else {
      // load comments for item and take care of other side panel logic
      this.context.executeAction(ToggleSidePanels, { itemId });
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/task/open_or_refresh_comment_panel.js